module.exports = __webpack_public_path__ + "img/133-saudi-arabia.d5618370.svg";